import { render, staticRenderFns } from "./PatientPrescriptionRequest.vue?vue&type=template&id=3f2ea382&scoped=true&lang=pug"
import script from "./PatientPrescriptionRequest.vue?vue&type=script&lang=js"
export * from "./PatientPrescriptionRequest.vue?vue&type=script&lang=js"
import style0 from "./PatientPrescriptionRequest.vue?vue&type=style&index=0&id=3f2ea382&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2ea382",
  null
  
)

export default component.exports